import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import logo from '../../logo.png';
import { Plus, Edit2, Trash2 } from 'lucide-react';

export default function Estructuras() {
  const navigate = useNavigate();
  const [estructuras, setEstructuras] = useState([]);
  const [catalogos, setCatalogos] = useState({ grupos: [], secciones: [], sectores: [] });
  const [loading, setLoading] = useState(true);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [form, setForm] = useState({
    nombre_estructura: '', tipo_estructura: '', grupo_politico_id: '',
    seccion_id: '', sector_id: '', observaciones: ''
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [estRes, catRes] = await Promise.all([
        api.get('/estructuras'),
        api.get('/estructuras/catalogos')
      ]);
      setEstructuras(estRes.data.estructuras);
      setCatalogos(catRes.data);
    } catch (error) {
      console.error('Error al cargar datos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/estructuras', form);
      setMensaje({ tipo: 'exito', texto: 'Estructura creada correctamente.' });
      setForm({ nombre_estructura: '', tipo_estructura: '', grupo_politico_id: '', seccion_id: '', sector_id: '', observaciones: '' });
      setMostrarForm(false);
      fetchData();
    } catch (error) {
      setMensaje({ tipo: 'error', texto: error.response?.data?.error || 'Error al crear estructura.' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">

      {/* Header */}
      <header className="text-white px-6 py-4 flex items-center justify-between shadow-lg"
        style={{ background: 'linear-gradient(135deg, #14532d 0%, #5c1022 100%)' }}>
        <img src={logo} alt="DOMINIUM" className="h-16" />
        <button onClick={() => navigate('/dashboard')}
          className="bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-lg text-sm transition">
          ← Volver al Dashboard
        </button>
      </header>

      <main className="p-6 max-w-6xl mx-auto">

        {/* Título y botón */}
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Gestión de Estructuras</h2>
            <p className="text-gray-500 text-sm">Administración de estructuras territoriales y sectoriales</p>
          </div>
          <button onClick={() => setMostrarForm(!mostrarForm)}
            className="text-white font-semibold px-5 py-2 rounded-xl hover:opacity-90 transition flex items-center gap-2"
            style={{ background: 'linear-gradient(135deg, #16a34a 0%, #9b1c35 100%)' }}>
            <Plus size={18} />
            {mostrarForm ? 'Cancelar' : 'Nueva Estructura'}
          </button>
        </div>

        {/* Mensaje */}
        {mensaje && (
          <div className={`mb-4 p-4 rounded-xl ${
            mensaje.tipo === 'exito' ? 'bg-green-50 border border-green-200 text-green-800' : 'bg-red-50 border border-red-200 text-red-800'
          }`}>
            {mensaje.texto}
          </div>
        )}

        {/* Formulario nueva estructura */}
        {mostrarForm && (
          <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
            <h3 className="font-semibold text-lg mb-4" style={{ color: '#14532d' }}>Nueva Estructura</h3>
            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Nombre de la Estructura *</label>
                <input name="nombre_estructura" value={form.nombre_estructura} onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                  required />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Estructura *</label>
                <select name="tipo_estructura" value={form.tipo_estructura} onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                  required>
                  <option value="">Seleccionar...</option>
                  <option value="territorial">Territorial</option>
                  <option value="sectorial">Sectorial</option>
                  <option value="politica">Política</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Grupo Político</label>
                <select name="grupo_politico_id" value={form.grupo_politico_id} onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                  <option value="">Seleccionar...</option>
                  {catalogos.grupos.map(g => (
                    <option key={g.id} value={g.id}>{g.nombre_grupo}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sección Electoral</label>
                <select name="seccion_id" value={form.seccion_id} onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                  <option value="">Seleccionar...</option>
                  {catalogos.secciones.map(s => (
                    <option key={s.id} value={s.id}>{s.numero_seccion} - {s.municipio}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sector</label>
                <select name="sector_id" value={form.sector_id} onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
                  <option value="">Seleccionar...</option>
                  {catalogos.sectores.map(s => (
                    <option key={s.id} value={s.id}>{s.nombre_sector}</option>
                  ))}
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Observaciones</label>
                <textarea name="observaciones" value={form.observaciones} onChange={handleChange}
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" />
              </div>
              <div className="md:col-span-2">
                <button type="submit"
                  className="w-full text-white font-semibold py-3 rounded-xl hover:opacity-90 transition"
                  style={{ background: 'linear-gradient(135deg, #16a34a 0%, #9b1c35 100%)' }}>
                  Crear Estructura
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Tabla de estructuras */}
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h3 className="font-semibold text-gray-800 mb-4">Estructuras del Sistema</h3>
          {loading ? (
            <p className="text-gray-500 text-center py-4">Cargando...</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-100">
                    <th className="text-left py-2 px-3 text-gray-500 font-medium">Nombre</th>
                    <th className="text-left py-2 px-3 text-gray-500 font-medium">Tipo</th>
                    <th className="text-left py-2 px-3 text-gray-500 font-medium">Grupo Político</th>
                    <th className="text-left py-2 px-3 text-gray-500 font-medium">Sección</th>
                    <th className="text-left py-2 px-3 text-gray-500 font-medium">Sector</th>
                    <th className="text-left py-2 px-3 text-gray-500 font-medium">Estatus</th>
                    <th className="text-left py-2 px-3 text-gray-500 font-medium">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {estructuras.map((e, i) => (
                    <tr key={i} className="border-b border-gray-50 hover:bg-gray-50">
                      <td className="py-2 px-3 font-medium text-gray-800">{e.nombre_estructura}</td>
                      <td className="py-2 px-3 text-gray-600 capitalize">{e.tipo_estructura}</td>
                      <td className="py-2 px-3 text-gray-600">{e.grupo_politico || '—'}</td>
                      <td className="py-2 px-3 text-gray-600">{e.seccion || '—'}</td>
                      <td className="py-2 px-3 text-gray-600">{e.sector || '—'}</td>
                      <td className="py-2 px-3">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          e.estatus === 'activo' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
                        }`}>
                          {e.estatus}
                        </span>
                      </td>
                      <td className="py-2 px-3 flex gap-2">
                        <button className="p-1 hover:bg-gray-200 rounded transition">
                          <Edit2 size={16} className="text-blue-600" />
                        </button>
                        <button className="p-1 hover:bg-gray-200 rounded transition">
                          <Trash2 size={16} className="text-red-600" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <p className="text-center text-gray-400 text-xs mt-4">
          DOMINIUM © 2026 — Zacatlán, Puebla | GARCOR Design
        </p>

      </main>
    </div>
  );
}